/**
 * Contact form submission
 * @param {Object} data - Contact form data
 * @param {string} data.name - Full name
 * @param {string} data.phone - Phone number
 * @param {string} data.email - Email address
 * @param {string} data.message - Message content
 * @returns {Promise} API response
 */
export const submitContactForm = async (data) => {
  const apiBase = process.env.REACT_APP_API_BASE;
  const contactUrl = apiBase ? `${apiBase.replace(/\/$/, '')}/contact` : '/api/contact';

  const response = await fetch(contactUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.message || 'Kontakt forma nije uspešno poslata.');
  }

  const body = await response.json();
  return body;
};

export default {
  submitContactForm,
};
